export default class Product {
    constructor() {
        this.product_name = null;
        this.customer_name = null;
        this.supplier_name = null;
        this.surface = null;
        this.article_number = null;
        this.thread_type = null;
        this.head = null;
        this.point = null;
        this.recess = null;
        this.ukvz = null;
        this.material = null;
        this.length = null;
        this.diameter = null;
        this.properties = {};
    }

}